import actionTypes from '../../../actions/actionTypes'
import GeneralRequestOverlay from './GeneralRequestOverlay'

const getContent = (requestType, status, error) => {
    const content = {
        title: null,
        text: null,
        showResult: false
    }

    switch(requestType) {
        case actionTypes.PROGRAM_FETCH_REQUEST:
            if(status.pending) {
                content.title = 'program_is_fetched'
            } else if(status.success) {
                content.title = 'program_was_fetched'
            } else if(status.error) {
                content.title = 'program_error_occurred_while_fetching'
                content.text = error.message,
                content.showResult = true
            }
            break
        case actionTypes.PROGRAM_GET_REQUEST:
            if(status.pending) {
                content.title = 'data_is_loading'
            } else if(status.error) {
                content.title = 'program_error_occurred_while_loading'
                content.text = error.message,
                content.showResult = true
            }
            break
            case actionTypes.PROGRAM_FILTER_REQUEST:
            if(status.pending) {
                content.title = 'program_is_created_and_published'
            } else if(status.success) {
                content.title = 'program_was_successfully_published'
            } else if(status.error) {
                content.title = 'program_error_occurred_while_adding'
                content.text = error.message,
                content.showResult = true
            }
            break
        case actionTypes.PROGRAM_UPDATE_REQUEST :
            if(status.pending) {
                content.title = 'program_is_published'
            } else if(status.success) {
                content.title = 'program_has_been_published'
            } else if(status.error) {
                content.title = 'program_error_occurred_while_publishing'
                content.text = error.message,
                content.showResult = true
            }
            break
        case actionTypes.PROGRAM_CREATE_ITEM_REQUEST:
            if(status.error) {
                content.title = 'program_error_occurred_while_adding'
                content.text = error.message,
                content.showResult = true
            }
            break
        case actionTypes.TMDB_MATCH_REQUEST:
            content.title = 'tmdb_is_being_linked'
            break
        case actionTypes.PREVIEW_MOVIES_CREATE_REQUEST:
            content.title = 'preview_movies_is_being_created'
            break
        case actionTypes.META_MERGE_REQUEST:
            content.title = 'meta_mapping_merge_is_loading'
            break
        case actionTypes.META_MOVE_REQUEST:
            content.title = 'meta_mapping_move_is_loading'
            break
        case actionTypes.META_SPLIT_REQUEST:
            content.title = 'meta_mapping_split_is_loading'
            break
    }

    return content
}

const RequestOverlay = ({status, error, uiRequestOverlay, onResetRequestOverlay}) => {
    const { requestType, overlayType } = uiRequestOverlay
    const { title, text, showResult } = getContent(requestType, status, error)

    return <GeneralRequestOverlay
        title={title}
        text={text}
        overlayType={overlayType}
        onResetOverlay={onResetRequestOverlay}
        showResult={showResult}
    />
}

export default RequestOverlay